import './polyfill';
import './main';
import './front';
import './interactive-map';
import './map';
import initializeActivities from './activities';
import initializeCatalog from './catalog';
import initializeContactInfo from './contact-info';
import { ContactInfoProps } from './contact-info/contact-info';
import { CatalogProps } from './catalog/catalog-container';
import './styles.scss';
import { PortAndWaterwayListContainerProps } from './port-and-waterway-list/features/krets/containers/port-and-waterway-list-container';
import initPortAndWaterwayList from './port-and-waterway-list';
import initializeFrontPage from './front-page';
import { findElements, byId } from '@mach25/find-elements';

const initActivities = (): void => {
  const el = document.getElementById('activities-anchor-point');
  if (el) {
    initializeActivities(el);
  }
};
const initCatalog = (): void => {
  const elements = window.document.querySelectorAll('.sxk-course-catalog');
  for (let i = 0; i < elements.length; i++) {
    const e = elements[i];
    if (e instanceof HTMLElement) {
      const config: CatalogProps = {};
      if (e.dataset.organizationid) {
        config.organizationId = e.dataset.organizationid;
      }
      if (e.dataset.typeid) {
        config.typeId = e.dataset.typeid;
      }
      if (e.dataset.webtypeid) {
        config.webTypeId = e.dataset.webtypeid;
      }
      if (e.dataset.fromdate) {
        config.fromDate = e.dataset.fromdate;
      }
      if (e.dataset.todate) {
        config.toDate = e.dataset.todate;
      }
      if (e.dataset.tag) {
        config.tag = e.dataset.tag;
      }
      if (e.dataset.title) {
        config.title = e.dataset.title;
      }
      initializeCatalog(e, config);
    }
  }
};
const initContactInfo = (): void => {
  const elements = window.document.querySelectorAll('.sxk-contact-info');
  for (let i = 0; i < elements.length; i++) {
    const e = elements[i];
    if (e instanceof HTMLElement) {
      const config: ContactInfoProps = {};
      if (e.dataset.organizationid) {
        config.organizationId = e.dataset.organizationid;
      }
      if (e.dataset.group) {
        config.group = e.dataset.group;
      }
      initializeContactInfo(e, config);
    }
  }
};
const initPortAndWaterwayObjectList = (): void => {
  const elements = window.document.querySelectorAll('.sxk-port-and-waterway-object-list');
  for (let i = 0; i < elements.length; i++) {
    const e = elements[i];
    if (e instanceof HTMLElement) {
      const config: PortAndWaterwayListContainerProps = {};
      if (e.dataset.organizationid) {
        config.organizationId = +e.dataset.organizationid;
      }
      if (e.dataset.title) {
        config.title = e.dataset.title;
      }
      initPortAndWaterwayList(e, config);
    }
  }
};
const initFrontPage = (): void => {
  findElements('sxk-front-page-container', byId)
    .then((e) => initializeFrontPage(e as HTMLElement))
    .catch((e) => console.warn(e.message));
};

window.document.addEventListener('DOMContentLoaded', function loadSXKComponents() {
  initActivities();
  initCatalog();
  initContactInfo();
  initPortAndWaterwayObjectList();
  initFrontPage();
});
